<template>
    <rkm-overlay>
        <rkm-layout-body>
            <template #title>
                <div class="title-container">
                    <h1>CONSULTA FÁCIL - FILA DE ESPERA</h1>
                    <div class="logo-container">
                        <img
                        :src="customer && customer.logotipo ? require(`@/assets/cliente/logotipo/${customer.logotipo}`) : null"
                        width="50"
                        />
                        <span>PREFEITURA MUNICIPAL DE {{customer ? customer.nome : null}}</span> 
                    </div>
                </div>
            </template>

            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import List from '@/components/regulacao-divulgacao/fila/List'

import { mapGetters } from 'vuex'

export default {
    components: { List },

    computed: {
        ...mapGetters({customer: 'getCustomer'}),
    },
}
</script>

<style>
.content-header-title {
    width: 100%;
}

.title-container {
    display: flex;
    align-items: center;
    justify-content: space-between; 
    width: 100%;
    padding: 0 1rem; 
}

.logo-container {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-weight: 500;
}

.title-container h1 {
    font-size: 1.3rem;
    letter-spacing: -0.5px;
    text-transform: uppercase;
    font-weight: 500;
    margin: 0;
}
</style>